import React from 'react';
import { useAppDispatch } from '../../../redux/hooks';
import {
  IBuilderAdditionalSettings,
  IBuilderAdditionalSettingsKey,
  setBuilderAdditionalSettings,
} from '../../../redux/slices/oldBuilder';
import InlineMultiSelectMenu from '../InlineMultiSelectMenu';

interface IProps {
  options: IBuilderAdditionalSettings[];
  selectedKeys: IBuilderAdditionalSettingsKey[];
}

const AdditionalSettings = ({ options, selectedKeys }: IProps) => {
  const dispatch = useAppDispatch();

  const handleSubmit = (selection: IBuilderAdditionalSettingsKey[]) => {
    dispatch(setBuilderAdditionalSettings(selection));
  };

  return (
    <InlineMultiSelectMenu
      label={'Additional Settings'}
      options={options.map((option) => ({
        label: option.name,
        value: option.key,
        tooltipOption: option.tooltip,
      }))}
      selectedKeys={selectedKeys}
      onSubmit={handleSubmit}
    />
  );
};

export default AdditionalSettings;
